// Collection Filters JS - Handles multi-filter selection with OR logic
document.addEventListener('DOMContentLoaded', function() {
  initializeCollectionFilters();
});

function initializeCollectionFilters() {
  // Initialize price range sliders
  initPriceSliders();
  
  // Set up event listeners
  setupFilterEvents();
  
  // Update active filters display
  updateActiveFilters();
  
  // Handle grid layout changes
  setupGridLayoutToggle();
  
  // Handle sort by dropdown
  setupSortByDropdown();
}

function initPriceSliders() {
  const priceSliders = document.querySelectorAll('.mall-slider-handles');
  
  priceSliders.forEach(slider => {
    const minInput = slider.parentElement.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = slider.parentElement.querySelector('input[name="filter.v.price.lte"]');
    const minValue = parseFloat(slider.dataset.min) || 0;
    const maxValue = parseFloat(slider.dataset.max) || 1000;
    const startMin = parseFloat(slider.dataset.start) || minValue;
    const startMax = parseFloat(slider.dataset.end) || maxValue;
    
    noUiSlider.create(slider, {
      start: [startMin, startMax],
      connect: true,
      range: {
        'min': minValue,
        'max': maxValue
      },
      step: 1
    });
    
    slider.noUiSlider.on('update', function(values, handle) {
      const value = values[handle];
      if (handle === 0) {
        minInput.value = Math.round(value);
      } else {
        maxInput.value = Math.round(value);
      }
    });
    
    slider.noUiSlider.on('change', function() {
      applyFilters();
    });
  });
}

function setupFilterEvents() {
  const filterForm = document.getElementById('FiltersForm');
  if (!filterForm) return;
  
  // Checkbox/radio filters
  filterForm.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      applyFilters();
    });
  });
  
  // Price input fields
  filterForm.querySelectorAll('input[type="number"]').forEach(input => {
    input.addEventListener('change', function() {
      applyFilters();
    });
  });
  
  // Clear all filters
  const clearAllBtn = document.querySelector('.yv-applied-filter-item a[href*="clear_all"]');
  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function(e) {
      e.preventDefault();
      clearAllFilters();
    });
  }
  
  // Remove individual filters
  document.addEventListener('click', function(e) {
    if (e.target.closest('.yv-applied-filter-remove') && !e.target.closest('.yv-applied-filter-cross-all')) {
      e.preventDefault();
      const filterUrl = e.target.closest('.yv-applied-filter-remove').getAttribute('href');
      navigateToFilterUrl(filterUrl);
    }
  });
}

function applyFilters() {
  const filterForm = document.getElementById('FiltersForm');
  const formData = new FormData(filterForm);
  const searchParams = new URLSearchParams();
  
  // Group filters by their param name for OR logic
  const filterGroups = {};
  
  formData.forEach((value, key) => {
    if (!filterGroups[key]) {
      filterGroups[key] = [];
    }
    // Only add if value is not empty
    if (value !== '') {
      filterGroups[key].push(value);
    }
  });
  
  // Build URL with OR logic for same filter groups
  Object.entries(filterGroups).forEach(([key, values]) => {
    if (key.startsWith('filter.v.')) {
      // Join multiple values with commas for OR filtering
      searchParams.append(key, values.join(','));
    } else {
      // Add other params normally
      values.forEach(val => searchParams.append(key, val));
    }
  });
  
  // Get current sort_by value if not already in form
  const currentSortBy = new URLSearchParams(window.location.search).get('sort_by');
  if (currentSortBy && !searchParams.has('sort_by')) {
    searchParams.append('sort_by', currentSortBy);
  }
  
  // Update URL without reloading the page
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  history.pushState({}, '', newUrl);
  
  // Fetch and update products
  fetchFilteredProducts(newUrl);
}

function fetchFilteredProducts(url) {
  showLoadingIndicator();
  
  // Add section parameter to get only the products HTML
  const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=main-collection-products`;
  
  fetch(fetchUrl)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const productsContainer = doc.getElementById('CollectionProductsContainer');
      
      if (productsContainer) {
        // Update products grid
        document.getElementById('CollectionProductsContainer').innerHTML = productsContainer.innerHTML;
        
        // Update active filters
        updateActiveFilters();
        
        // Update product count
        updateProductCount(doc);
        
        // Update pagination
        updatePagination(doc);
        
        // Reinitialize any product-related JS
        initProductGridItems();
      }
    })
    .catch(error => {
      console.error('Error fetching filtered products:', error);
    })
    .finally(() => {
      hideLoadingIndicator();
    });
}

function updateActiveFilters() {
  const activeFiltersContainer = document.querySelector('.yv-products-applied-filter');
  if (!activeFiltersContainer) return;
  
  const params = new URLSearchParams(window.location.search);
  let activeFiltersHTML = '';
  
  params.forEach((value, key) => {
    if (key.startsWith('filter.v.')) {
      const filterName = key.replace('filter.v.', '').replace(/\./g, ' ');
      const values = value.split(',');
      
      values.forEach(val => {
        activeFiltersHTML += `
          <li class="yv-applied-filter-item">
            <a href="${removeFilterFromUrl(key, val)}" class="yv-applied-filter-remove">
              ${formatFilterLabel(filterName, val)}
              <span class="yv-applied-filter-cross">×</span>
            </a>
          </li>
        `;
      });
    }
  });
  
  if (activeFiltersHTML) {
    activeFiltersContainer.innerHTML = activeFiltersHTML + `
      <li class="yv-applied-filter-item">
        <a href="${window.location.pathname}" class="yv-applied-filter-remove">
          ${Shopify.translation.clear_all || 'Clear all'}
        </a>
      </li>
    `;
  } else {
    activeFiltersContainer.innerHTML = '';
  }
}

function removeFilterFromUrl(filterKey, filterValue) {
  const params = new URLSearchParams(window.location.search);
  const currentValues = params.get(filterKey)?.split(',') || [];
  
  // Remove the specific value
  const updatedValues = currentValues.filter(val => val !== filterValue);
  
  if (updatedValues.length > 0) {
    params.set(filterKey, updatedValues.join(','));
  } else {
    params.delete(filterKey);
  }
  
  return `${window.location.pathname}?${params.toString()}`;
}

function formatFilterLabel(filterName, value) {
  // Format the filter label for display
  return `${filterName}: ${value}`;
}

function clearAllFilters() {
  navigateToFilterUrl(window.location.pathname);
}

function navigateToFilterUrl(url) {
  history.pushState({}, '', url);
  fetchFilteredProducts(url);
}

function updateProductCount(doc) {
  const countElement = doc.querySelector('.products-count');
  if (countElement) {
    const currentCountElement = document.querySelector('.products-count');
    if (currentCountElement) {
      currentCountElement.innerHTML = countElement.innerHTML;
    }
  }
}

function updatePagination(doc) {
  const paginationElement = doc.querySelector('.pagination');
  if (paginationElement) {
    const currentPaginationElement = document.querySelector('.pagination');
    if (currentPaginationElement) {
      currentPaginationElement.innerHTML = paginationElement.innerHTML;
    } else {
      document.querySelector('[data-collection-products]').insertAdjacentHTML('afterend', paginationElement.outerHTML);
    }
  }
}

function showLoadingIndicator() {
  const loader = document.createElement('div');
  loader.className = 'collection-loading-overlay';
  loader.innerHTML = `
    <div class="loader">
      <svg width="50" height="50" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" stroke-width="5" stroke="#000" fill="none" stroke-dasharray="31.415, 31.415">
          <animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
        </circle>
      </svg>
    </div>
  `;
  document.getElementById('CollectionProductsContainer').appendChild(loader);
}

function hideLoadingIndicator() {
  const loader = document.querySelector('.collection-loading-overlay');
  if (loader) {
    loader.remove();
  }
}

function setupGridLayoutToggle() {
  const layoutButtons = document.querySelectorAll('.sort-grid-icon');
  const productsContainer = document.getElementById('CollectionProductsContainer');
  
  if (!layoutButtons.length || !productsContainer) return;
  
  layoutButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (!this.classList.contains('active')) {
        // Update active class
        layoutButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');
        
        // Get layout value
        const layout = this.dataset.value;
        productsContainer.setAttribute('data-view', layout);
        
        // Update cookie
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = `grid_layout_collection=${layout}; expires=${date.toUTCString()}; path=/`;
        
        // Update grid classes
        updateGridLayout(layout);
      }
    });
  });
  
  // Initialize from cookie
  const layoutCookie = document.cookie.split('; ').find(row => row.startsWith('grid_layout_collection='));
  const savedLayout = layoutCookie ? layoutCookie.split('=')[1] : 'grid-layout-4';
  
  const savedButton = document.querySelector(`.sort-grid-icon[data-value="${savedLayout}"]`);
  if (savedButton) {
    savedButton.click();
  }
}

function updateGridLayout(layout) {
  const productItems = document.querySelectorAll('[data-product-grid]');
  if (!productItems.length) return;
  
  let columnClass = 'col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3'; // Default
  
  switch(layout) {
    case 'grid-layout-2':
      columnClass = 'col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6';
      break;
    case 'grid-layout-3':
      columnClass = 'col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4';
      break;
    case 'grid-layout-4':
      columnClass = 'col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3';
      break;
    case 'grid-layout-5':
      columnClass = 'col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2';
      break;
  }
  
  productItems.forEach(item => {
    item.className = columnClass;
  });
}

function setupSortByDropdown() {
  const sortBySelected = document.querySelector('.collection-sortby-selected');
  const sortList = document.getElementById('sort__list');
  const closeSort = document.querySelector('.close-sort');
  
  if (!sortBySelected || !sortList) return;
  
  sortBySelected.addEventListener('click', function(e) {
    e.preventDefault();
    sortList.classList.toggle('active');
    
    if (window.innerWidth <= 767) {
      document.body.classList.toggle('open-filter-sort');
    }
  });
  
  if (closeSort) {
    closeSort.addEventListener('click', function(e) {
      e.preventDefault();
      sortList.classList.remove('active');
      document.body.classList.remove('open-filter-sort');
    });
  }
  
  // Close when clicking outside
  document.addEventListener('click', function(e) {
    if (!sortBySelected.contains(e.target) && !sortList.contains(e.target)) {
      sortList.classList.remove('active');
      document.body.classList.remove('open-filter-sort');
    }
  });
}

function initProductGridItems() {
  // Initialize any product-related JS (quick view, wishlist, etc.)
  if (typeof initProductCards === 'function') {
    initProductCards();
  }
  
  // Initialize lazy loading
  if (typeof initLazyLoad === 'function') {
    initLazyLoad();
  }
}







































